@if (validInquiryElements) {
  <ul class="waste-list">
    @for (
      element of validInquiryElements.slice(0, truncateAfterIndex);
      track element
    ) {
      <li>
        <app-round-icon class="mr-1 icon"> delete_outline </app-round-icon>
        <span class="waste-list__text">
          <app-waste-title [class.missing]="missing" [element]="element" />
        </span>
      </li>
    }
    @if (showAll) {
      @for (
        element of validInquiryElements.slice(truncateAfterIndex);
        track element
      ) {
        <li>
          <app-round-icon class="mr-1 icon"> delete_outline </app-round-icon>
          <span class="waste-list__text">
            <app-waste-title [class.missing]="missing" [element]="element" />
          </span>
        </li>
      }
    }
  </ul>
  @if (validInquiryElements.length > truncateAfterIndex) {
    @if (!showAll) {
      <button
        mat-button
        (click)="showAll = true"
        [attr.aria-expanded]="showAll"
        class="mt-2"
      >
        {{ validInquiryElements.length - truncateAfterIndex }} weitere anzeigen…
      </button>
    }
  }
}
